import React from 'react';
import {Box, Button} from '@mui/material';

import {EmptySearchState} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {translations} from 'presentation/translations-new';
import {useCallChatRoom, useMediaQueries} from 'presentation/pages/private/hooks';
import {ChatRoomsEnum} from 'presentation/constants';
import {FlowEnum} from '../../constants';
import {BookingEmptyStateProps} from './types';

const {noResults, callToChat, clearFilters} = translations['pt-br'].commons;

export function BookingEmptyState({
	description,
	internalPadding,
	title = noResults,
	flowType,
	dataTagId,
	clearFilter,
}: BookingEmptyStateProps) {
	const {isMobile} = useMediaQueries();
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();

	const isOdonto = flowType === FlowEnum.ODONTO;
	const isExam = flowType === FlowEnum.EXAM;

	const customPadding = isMobile ? 2 : 4;

	async function handleCallChatRoom() {
		let type = ChatRoomsEnum.APP;

		if (isOdonto) {
			type = ChatRoomsEnum.ODONTO;
		}

		if (isExam) {
			type = ChatRoomsEnum.EXAMS;
		}
		await callChatRoom(type);
	}

	return (
		<Box p={internalPadding ? customPadding : 0}>
			<EmptySearchState title={title} description={description} dataTagId={dataTagId}>
				<Button
					size="large"
					onClick={handleCallChatRoom}
					endIcon={callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null}
					disabled={callChatRoomIsLoading}>
					{callToChat}
				</Button>
				{clearFilter ? (
					<Button size="large" variant="outlined" onClick={clearFilter}>
						{clearFilters}
					</Button>
				) : null}
			</EmptySearchState>
		</Box>
	);
}
